<template>
  <div id="AnalyistSelectModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">{{title}}</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>{{labelForOrg}}</th><td><input type="text" v-model="orgName"/></td>
              <template v-if="canSelect">
                <th>種別</th>
                  <td>
                    <select id="SelcectRole" v-model="selectedRole">
                      <option value=""></option>
                      <option v-if="canSelectRole(role.role_hospital)" :value="role.role_hospital">医療機関</option>
                      <option v-if="canSelectRole(role.role_corporation)" :value="role.role_corporation">企業</option>
                      <option v-if="canSelectRole(role.role_judgment)" :value="role.role_judgment">判定医療機関</option>
                      <option v-if="canSelectRole(role.role_analysis)" :value="role.role_analysis">解析委託業者</option>
                      <option v-if="canSelectRole(role.role_dealer)" :value="role.role_dealer">ディーラー</option>
                    </select>
                  </td>
                <td colspan="3"></td>
              </template>
              <template v-else>
                <td colspan="5"></td>
              </template>
            </tr>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;text-align: center;">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area">
          <b-table
            v-if="data.length > 0"
            id="customerSelectTable"
            :data="data"
            paginated
            per-page="20"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="customerId" label="" width="20" centered>
                <b-radio class="customRadio" name="radioItem" v-model="selectedItem" :native-value="props.row"></b-radio>
              </b-table-column>
              <b-table-column field="orgName" :label="labelForOrg" width="300" sortable >{{props.row.orgName}}</b-table-column>
              <b-table-column field="roleName" label="種別" width="100" sortable >{{props.row.roleName}}</b-table-column>
              <b-table-column field="address" label="住所" width="500" sortable >{{props.row.address}}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="!selectedItem">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
export default {
  name: "AnalyistSelectModal",
  props: {
    title:{default:"組織選択"},
    labelForOrg:{default:"組織名"},
    selectRole:{type:[Array], default: () => [], },
    canSelect: {default: false}
  },
  methods: {
    save: function() {
      this.$emit('select', this.selectedItem);
      this.$parent.close();
    },
    doSearch: function() {
      let _this = this;
      let roleList = [];
      if(!this.selectedRole){
         roleList = this.selectRole;
      } else {
        roleList.push(this.selectedRole)
      }
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getAnalyistListPOST({
            body:{
              orgName:_this.orgName,
              roleList:roleList
            }
          });
        },
        function(result) {
          // 検索結果取得
          _this.data = result.obj
        },
        function(result) {
          // エラーメッセージ表示
          _this.showErrorMessage(result);
        },
      );
    },

    canSelectRole: function(selectValue) {
      var ret = true;
      if(this.selectRole){
        ret = this.selectRole.indexOf(selectValue) > -1;
      }
      return ret;
    },
  },
  data() {
    return {
      role: role,
      data: [],
      orgName:"",
      selectedRole:"",
      selectedItem:'',
    };
  },
  filters: {},
  components: {},
  mounted: function () {},
};
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/AnalyistSelectModal.vue